module.exports = __webpack_public_path__ + "img/it.1a3b54c.jpg";